<div class="subscriptions-page">
    <div class="container-fluid clearfix">
        <span class="subheader">INDEX ARCHIVING</span>
        <h1>Subscription</h1>
        <mat-card class="card-style" [hidden]="isConfirmed">
            <div class="row center-container">
                <div class="col-sm-12">
                    <div class="row" style="max-width: 350px;">
                        <div class="col-sm-12">
                            <label id="options-radio-group-label"><h4 class="subscriptions-page">Subscription Information</h4></label>
                        </div>
                    </div>
                    <div class="row" style="max-width: 350px; margin-top: 35px;">
                        <div class="col-sm-12">
                            <div class="col-sm-auto p-0">
                                <app-single-dropbox class="single-dropbox"
                                    [allowMultiple]="true"
                                    cssClassToApply="dropbox-w-300 single-dropbox-custom"
                                    popupPositionLeft="44"
                                    [(ngModel)]="stations"
                                    placeholder="Select Station"
                                    placeholderLabel="Find a station..."
                                    noEntriesFoundLabel="No station found"
                                    #stationMulti>
                                </app-single-dropbox>
                            </div>
                        </div>
                    </div>
                    <div class="row" style="max-width: 350px; margin-top: 15px;">
                        <div class="col-sm-12">
                        <div class="col-sm-auto p-0">
                        <mat-form-field class="dropbox-w-300 day-picker">
                            <mat-label>Select Day</mat-label>
                            <mat-select [(ngModel)]="selectedDay" multiple>
                              <mat-option value="SUNDAY">Sunday</mat-option>
                              <mat-option value="MONDAY">Monday</mat-option>
                              <mat-option value="TUESDAY">Tuesday</mat-option>
                              <mat-option value="WEDNESDAY">Wednesday</mat-option>
                              <mat-option value="THURSDAY">Thursday</mat-option>
                              <mat-option value="FRIDAY">Friday</mat-option>
                              <mat-option value="SATURDAY">Saturday</mat-option>
                            </mat-select>
                          </mat-form-field>
                          </div>
                        </div>
                    </div>
                    <div class="row" style="max-width: 350px; margin-top: 15px;">
                        <div class="col-sm-12">
                            <app-single-time-picker
                                [timeFormControl]="myForm.controls.startTime"
                                showLabel="Start Time"
                                (modelChange)="startTimeChanged($event)"
                                #startTimePicker>
                            </app-single-time-picker>
                        </div>
                    </div>
                    <div class="row" style="max-width: 350px; margin-top: 15px;">
                        <div class="col-sm-12">
                            <app-single-time-picker
                                [timeFormControl]="myForm.controls.endTime"
                                showLabel="End Time (Max 90 min from Start Time)"
                                #endTimePicker>
                            </app-single-time-picker>
                        </div>
                    </div> 
   
                    <div class="row" style="max-width: 350px; margin-top: 15px;">
                        <div class="col-sm-12">
                            <mat-form-field style="width: 315px;">
                                <input required #emailBox matInput placeholder="Email Address" aria-label="Email" [formControl]="emailCtrl">
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 35px;">
                        <div class="col-sm-12 p-0">
                            <button mat-button class="float-left" (click)="clear()">CLEAR FIELDS</button>
                            <button
                                [class.primary-button-disabled]="disableSubmitButton"
                                [class.primary-button]="!disableSubmitButton"
                                [disabled]="disableSubmitButton"
                                mat-button (click)="submit()"
                                class="float-right no-outline" style="margin-right: 15px;">SUBMIT</button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card>
        <mat-card class="card-style" [hidden]="!isConfirmed">
            <div class="row center-container">
                <div class="col-sm-12">
                    <p style="max-width: 500px;text-align: center;">
                        Thank you! You’ve requested a subscription for transcriptions from <b>{{ displayedStationName }}</b> on <b>{{ displayedWeekDay }}</b> starting at <b>{{ displayedStartTime }}</b> and ending at <b>{{ displayedEndTime }}</b>. 
                        You’ll receive an email when your files are ready to download.
                    </p>
                </div>
            </div>
            <div class="row center-container">
                <div class="col-sm-2">
                    <button mat-button class="float-left" (click)="isConfirmed = false">Back</button>
                </div>
            </div>
            <button mat-icon-button class="close-button" (click)="isConfirmed = false">
                <mat-icon>close</mat-icon>
            </button>
        </mat-card>
    </div>
</div>